import { render, staticRenderFns } from "./ghacReg.vue?vue&type=template&id=2dce7f66&scoped=true&"
import script from "./ghacReg.vue?vue&type=script&lang=js&"
export * from "./ghacReg.vue?vue&type=script&lang=js&"
import style0 from "./ghacReg.vue?vue&type=style&index=0&id=2dce7f66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dce7f66",
  null
  
)

export default component.exports